// start:ng42.barrel
import './profile-popup.controller';
// end:ng42.barrel

